// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ObjectFitMath from "object-fit-math";
function fitAndPositionFloat(prim0, prim1, prim2) {
  return ObjectFitMath.fitAndPosition(prim0, prim1, prim2);
}
function fitAndPosition(a, b, mode) {
  var res1 = ObjectFitMath.fitAndPosition(a, b, mode);
  return {
    x: res1.x | 0,
    y: res1.y | 0,
    width: res1.width | 0,
    height: res1.height | 0
  };
}
export { fitAndPositionFloat, fitAndPosition };
/* object-fit-math Not a pure module */